const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Indent Freight Charge',
  description: 'Ability add base freight while creating an open indent ',
  sortOrder: 1,
  name: 'indentFreightCharge',
  documentKey: 'indent_freight_charge',
  values: {
    indent_freight_charge: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Indent Freight Charge',
      documentKey: 'indent_freight_charge',
    },
  },
};
